import { render, staticRenderFns } from "./classifyTree.vue?vue&type=template&id=29760ff7&"
import script from "./classifyTree.vue?vue&type=script&lang=js&"
export * from "./classifyTree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports